import React from 'react';
import cn from '../../lib/bem';
import InputMask from 'react-input-mask';

import './inputDate_component.scss';

const InputDateComponent = (props) => {
  const classes = cn('inputDateComponent');

  const onChangeInputActionDate = (value) => {
    props.inputActionMsg('');
    props.inputAction(value);
  };

  return (
    <div className={classes()} style={{ width: `${props.inputWidth}%` }}>
      <label className={classes('inputDateLabel')}>{props.inputText}</label>
      <InputMask
        mask="99/99/9999"
        className={
          props.inputMsg === ''
            ? classes('inputDate')
            : classes('inputDate inputError')
        }
        value={props.inputValue}
        onChange={(e) => onChangeInputActionDate(e.target.value)}
        placeholder="dd/mm/aaaa"
      />
      <label className={classes('inputDateLabelError')}>{props.inputMsg}</label>
    </div>
  );
};

export default InputDateComponent;
